import { render, staticRenderFns } from "./edit_merge_video_form.vue?vue&type=template&id=2e1b766f"
import script from "./edit_merge_video_form.vue?vue&type=script&lang=js"
export * from "./edit_merge_video_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports